import { getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function resetPassword(email) {
    return await Vue.axios.post(`${getApiUrl('v4')}/users/reset_password`, {
        email,
    });
}
